import { LogRocketAnalyticsService } from './log-rocket';
import { Pendo } from './pendo';
import { Segment } from './segment';
import { SentryService } from './sentry';

export const AnalyticsServices = [LogRocketAnalyticsService, Segment, SentryService, Pendo];
